import { render, staticRenderFns } from "./insuranceInfo.vue?vue&type=template&id=8ed6e0a4&scoped=true"
import script from "./insuranceInfo.vue?vue&type=script&lang=js"
export * from "./insuranceInfo.vue?vue&type=script&lang=js"
import style0 from "./insuranceInfo.vue?vue&type=style&index=0&id=8ed6e0a4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ed6e0a4",
  null
  
)

export default component.exports